import { _getModelClass, _getModelName, _getStoreFromRecord, buildOperationUrl } from './build-url';
import { strictifyHttpVerb } from './types';
export default function collectionOp(options) {
  return function runCollectionOp(payload) {
    const model = this;
    const recordClass = _getModelClass(model);
    const modelName = _getModelName(recordClass);
    const store = _getStoreFromRecord(model);
    const requestType = strictifyHttpVerb(options.type || 'put');
    const urlType = options.urlType || 'updateRecord';
    const adapter = store.adapterFor(modelName);
    const fullUrl = buildOperationUrl(model, options.path, urlType, false);
    const data = options.before && options.before.call(model, payload) || payload;
    return adapter.ajax(fullUrl, requestType, Object.assign(options.ajaxOptions || {}, {
      data
    })).then(response => {
      if (options.after && !model.isDestroyed) {
        return options.after.call(model, response);
      }
      return response;
    });
  };
}